import React from 'react'
import BaseComponent from '../../../common/base';
import { Card, Button } from 'react-bootstrap';
import QuestionnairePartialCard from '../../partials/card';
import coverPhoto from '../../../../assets/images/compass3x.png'

export class StepPreparationGeolocation extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = Object.assign(
            this.state,
            {
                lat: null,
                lng: null,
                acc: null,
                ts: null,
                isWorking: null,
                isSupported: null
            }
        )

    }

    updatePosition(position) {
        this.setState({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            acc: position.coords.accuracy,
            ts: position.timestamp,
            isWorking: true,
            isSupported: true
        });
        this.props.dbSet('geolocation.lat', position.coords.latitude);
        this.props.dbSet('geolocation.lng', position.coords.longitude);
        this.props.dbSet('geolocation.acc', position.coords.accuracy);
        this.props.dbSet('geolocation.ts', position.timestamp);
        this.props.dbSet('geolocation.isWorking', true);
        this.props.dbSet('geolocation.isSupported', true);
    }

    handleLocationError(isSupported) {
        this.setState({
            isWorking: false,
            isSupported: isSupported
        });
        this.props.dbSet('geolocation.isWorking', false);
        this.props.dbSet('geolocation.isSupported', isSupported);
    }

    initGeolocation() {
        let self = this;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    self.updatePosition(position);
                },
                (error) => {
                    self.handleLocationError(true);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                }
            );
        } else {
            self.handleLocationError(false);
        }
    }

    render() {
        return (
            <>
                <QuestionnairePartialCard
                    img={coverPhoto}
                    title={this.t('questionnaire.preparation.geolocation.title')}
                    body={
                        <>
                            <Card.Text>
                                {this.t('questionnaire.preparation.geolocation.text')}
                            </Card.Text>
                            {
                                this.state.isWorking === null
                                    ?
                                    (
                                        <Button
                                            variant="primary"
                                            onClick={(e) => this.initGeolocation()}
                                        >
                                            {this.t('questionnaire.preparation.geolocation.share')}
                                        </Button>
                                    )
                                    :
                                    this.state.isWorking === true
                                        ?
                                        (
                                            <>
                                                <Card.Text>
                                                    {this.t('questionnaire.preparation.geolocation.isWorking')}
                                                </Card.Text>
                                                <Button
                                                    variant="primary"
                                                    onClick={(e) => this.props.nextStep()}
                                                >
                                                    {this.t('questionnaire.common.nextStep')}
                                                </Button>
                                            </>
                                        )
                                        :
                                        (
                                            <>
                                                <Card.Text>
                                                    {this.t('questionnaire.preparation.geolocation.isNotWorking')}
                                                </Card.Text>
                                                <Button
                                                    variant="primary"
                                                    onClick={(e) => this.props.nextStep()}
                                                >
                                                    {this.t('questionnaire.common.nextStep')}
                                                </Button>
                                            </>
                                        )
                            }

                        </>
                    }
                    footer={
                        <>
                            <Button
                                variant="light"
                                className="float-right"
                                onClick={(e) => this.props.nextStep(e)}
                            >
                                {this.t('questionnaire.common.skip')}
                            </Button>
                        </>
                    }
                />
            </>
        )
    }

}

export default StepPreparationGeolocation;